import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { CourseSubmission } from 'types';

import { apiQuery } from '../../query';
import { courseStepsApi } from '../course-steps';
import { courseStepSubmissionsApi } from '../course-step-submissions';

import { CourseSubmissionResponse } from './types';

const tagType = 'COURSE_SUBMISSIONS';

const tagTypes = [tagType];

export const courseSubmissionsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'courseSubmissionsApi',
  endpoints: (build) => ({
    trackStepDocumentDownload: build.mutation<void, string>({
      query: (submissionId) => ({
        method: 'patch',
        url: URL.COURSE_SUBMISSIONS_STEP_DOCUMENT_DOWNLOADED.replace(
          ':id',
          submissionId
        ),
      }),
    }),
    last: build.query<CourseSubmission | undefined, void>({
      providesTags: tagTypes,
      transformResponse: (response: CourseSubmissionResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.COURSE_SUBMISSIONS_LAST,
      }),
    }),
    reset: build.mutation<void, void>({
      invalidatesTags: tagTypes,
      query: () => ({
        method: 'post',
        url: URL.COURSE_SUBMISSIONS_RESET,
      }),
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(courseStepsApi.util.invalidateTags(['COURSE_STEPS']));
          dispatch(
            courseStepSubmissionsApi.util.invalidateTags([
              'COURSE_STEP_SUBMISSIONS',
            ])
          );
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const {
  useLastQuery,
  useResetMutation,
  useTrackStepDocumentDownloadMutation,
} = courseSubmissionsApi;

export { tagType as courseSubmissionsTagType };
